import { useQuery } from '@tanstack/react-query';
import credentialsAPI from 'api/credentialsAPI';
import { credentialsQueries } from 'queryKeys/credentials';
import { UseQueryResult } from '@tanstack/react-query';
import { CredentialWithVerification } from 'types';
import { AxiosError } from 'axios';

export const useQueryGetCredentials = (
  candidateId: number
): UseQueryResult<CredentialWithVerification[], AxiosError> => {
  return useQuery({
    queryKey: credentialsQueries.list(candidateId).queryKey,
    queryFn: () => credentialsAPI.getCredentials(candidateId),
  });
};
